<template>
  <ul class="card-marketing">
    <li
      v-for="(field, index) in fields"
      :key="`card-marketing-field-${index}`"
      class="card-marketing__field"
    >
      <p>
        <span class="card-marketing__label">{{ field.label }}</span>
        <span class="card-marketing__tag--grey">{{ field.data }}</span>
        <HdTooltipped
          v-if="field.has_tooltip"
          :value="$t('DASHBOARD.CARD.EXPANDED.MARKETING.TOOLTIP')"
          :component="HdIcon"
          :props="{ src: icons.support }"
        />
      </p>
    </li>
  </ul>
</template>

<script>
import { HdIcon, HdTooltipped } from 'homeday-blocks';
import { support } from 'homeday-assets';

export default {
  name: 'CardMarketing',
  // eslint-disable-next-line vue/no-unused-components
  components: { HdTooltipped, HdIcon },
  props: {
    deal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      HdIcon,
    };
  },
  computed: {
    icons() {
      return {
        support,
      };
    },
    fields() {
      const {
        displayed_in_search_results_count: displayedInSearchResults,
        expose_hits_count: exposeViews,
        buyer_requests_count: buyerRequests,
        completed_viewings_count: completedViewings,
      } = this.deal.marketing_stats || {};

      return [
        {
          label: this.$t('DASHBOARD.CARD.EXPANDED.MARKETING.DISPLAYED_IN_SEARCH_RESULTS'),
          data: this.$formatNumber(displayedInSearchResults),
        },
        {
          label: this.$t('DASHBOARD.CARD.EXPANDED.MARKETING.EXPOSE_VIEWS'),
          data: this.$formatNumber(exposeViews),
          has_tooltip: true,
        },
        {
          label: this.$t('DASHBOARD.CARD.EXPANDED.MARKETING.CONTACT_REQUESTS'),
          data: this.$formatNumber(buyerRequests),
        },
        {
          label: this.$t('DASHBOARD.CARD.EXPANDED.MARKETING.VISITS'),
          data: this.$formatNumber(completedViewings),
        },
      ].filter((field) => field.data);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.card-marketing {
  &__field {
    margin-bottom: $sp-s;

    @include for('tablet') {
      margin-bottom: $sp-m + $sp-s;
    }

    p {
      align-items: center;
      display: flex;
      gap: $sp-s;

      svg {
        height: 20px;
        width: 20px;
      }
    }
  }

  &__label {
    @include font('DS-90');
    font-weight: 700;

    @include for('tablet') {
      @include font('DS-100');
    }
  }

  &__tag--grey {
    @include font('DS-80');
    background-color: getShade($quaternary-color, 50);
    border-radius: $sp-s;
    padding: $sp-s;

    @include for('tablet') {
      @include font('DS-100');
      padding: $sp-xs $sp-m - $sp-xs;
    }
  }

  button {
    margin-top: $sp-m;
    width: 100%;
  }
}
</style>
